module.exports = __webpack_public_path__ + "img/history_timeline_7.1ab27725.png";